import { render, staticRenderFns } from "./AddFont.vue?vue&type=template&id=4f1874a9&scoped=true"
import script from "./AddFont.vue?vue&type=script&lang=js"
export * from "./AddFont.vue?vue&type=script&lang=js"
import style0 from "./AddFont.vue?vue&type=style&index=0&id=4f1874a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1874a9",
  null
  
)

export default component.exports